import React, {useEffect, useState} from "react";
import "./styles/style.scss";
import {SelectButton} from "primereact/selectbutton";
import {addToDate} from "utils/time-utils";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import { ChronoUnitStr } from "api/model/enums";

type DateTimeRangeSelectionProps = {
    selectDateFrom: any;
    dateFrom: Date | undefined;
    selectDateTo: any;
    dateTo: Date | undefined;
    invalidRange: boolean;
    initialTimeOffset?: ChronoUnitStr
};

const DateTimeRangeSelection = ({selectDateFrom, dateFrom, selectDateTo, dateTo, invalidRange, initialTimeOffset}: DateTimeRangeSelectionProps) => {

    const [selectedTimeOffset, setSelectedTimeOffset] = useState<string | undefined>(initialTimeOffset);
    const offsetOptions = [
        {label: "m", value: "MINUTES"},
        {label: "10m", value: "10MINUTES"},
        {label: "H/2", value: "HALFHOUR"},
        {label: "H", value: "HOURS"},
        {label: "D/2", value: "HALFDAY"},
        {label: "D", value: "DAYS"},
        {label: "W", value: "WEEKS"},
        {label: "M", value: "MONTHS"},
    ];

    const handleOnSelectDateFrom = (dateFrom: Date | Date[] | undefined) => {
        if (selectedTimeOffset) {
            setSelectedTimeOffset(undefined)
        }
        selectDateFrom(dateFrom);
    };

    const handleOnSelectDateTo = (dateTo: Date | Date[] | undefined) => {
        if (selectedTimeOffset) {
            setSelectedTimeOffset(undefined)
        }
        selectDateTo(dateTo);
    };

    const onSelectButtonChange = (e: any) => {
        setSelectedTimeOffset(e.value);
    };

    useEffect(() => {
        if (selectedTimeOffset) {
            selectDateFrom(addToDate(new Date(dateTo as Date), -1, selectedTimeOffset));
        }
    }, [selectedTimeOffset]);

    return (
        <div className="dateRange ml-1">
      <span className="p-float-label justify-content-center align-text-center calendarItem">
        <CalendarWrapper id="datetimeFrom"
                         value={dateFrom}
                         onChange={(e) => handleOnSelectDateFrom(e)}
        />
        <label htmlFor="datetimeFrom">Select datetime from</label>
          {invalidRange && <p className="error">must be before "To date"</p>}
      </span>
            <span className="p-float-label justify-content-center align-text-center calendarItem">
        <CalendarWrapper value={dateTo}
                         onChange={(e) => handleOnSelectDateTo(e)}
        />
        <label htmlFor="datetimeTo">Select datetime to</label>
                {invalidRange && <p className="error">must be after "From date"</p>}
      </span>
            <div style={{flexWrap: "nowrap", whiteSpace: "nowrap"}}>
                <SelectButton value={selectedTimeOffset} options={offsetOptions} onChange={onSelectButtonChange}
                              className="select-button-class"/>
            </div>
        </div>
    );
};

export default DateTimeRangeSelection;
